import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import { Link } from "react-router-dom";

const InquireNotificationDialog = ({ open, onCancel, isLoggedIn }) => {
    return (
        <DiaglogBox width={400} open={open} onCancel={onCancel}>
            <div className="pb-5">
                <h4
                    className="pt-8 pb-9 w-full text-black text-[1.5625rem] font-bold text-center"
                    style={{
                        background: "url('/images/purple_wave_bg.svg')",
                        backgroundRepeat: "no-repeat",
                    }}
                >
                    Notification
                </h4>
                <p className="text-center font-bold text-[17px] px-11">
                    To Inquire about this Carbon credit sign in with buyer or
                    trader account!
                </p>
                <div className="px-10 flex justify-center mt-4">
                    {!isLoggedIn ? (
                        <Link to={"/user-portal"}>
                            <Button
                                color={"blue"}
                                className={
                                    "w-[150px] h-[40px] text-white text-sm font-bold"
                                }
                                varient={"primary"}
                            >
                                Log-in / Sign-up
                            </Button>
                        </Link>
                    ) : (
                        <Button
                            color={"blue"}
                            className={
                                "w-[150px] h-[40px] text-white text-sm font-bold"
                            }
                            varient={"primary"}
                            onClick={onCancel}
                        >
                            Ok
                        </Button>
                    )}
                </div>
            </div>
        </DiaglogBox>
    );
};

export default InquireNotificationDialog;
